import { Suspense } from 'react';
import { Outlet, useLocation, useMatches, useSearchParams } from 'react-router-dom';

import { PageLoading } from '../../core-components/theme/components/Screen/ScreenStates';

import { NoAccessScreen } from '../components/NoAccessScreen';
import { useAccessContext } from '../hooks';
import { reportBranchWouldDeny } from '../reporting';

import { decideBranch } from './routeAccess';

// Safety net: a page that suspends without its own boundary would otherwise crash
// on navigations that render synchronously (routes without a loader).
const PageOutlet = () => (
  <Suspense fallback={<PageLoading />}>
    <Outlet />
  </Suspense>
);

export const RouteAccessGate = () => {
  const matches = useMatches();
  const [searchParams] = useSearchParams();
  const { pathname } = useLocation();
  const { me, policy } = useAccessContext();
  const branch = decideBranch(me, matches, searchParams);

  if (branch.decision.allow) return <PageOutlet />;
  if (policy === 'report-only') {
    reportBranchWouldDeny(branch, pathname);
    return <PageOutlet />;
  }
  return <NoAccessScreen key={pathname} reason={branch.decision.reason} atPlant={branch.failed?.scope.kind === 'plant'} />;
};
